import { SearchListingsOperationModel } from "./search-listings-operation-model";


export const models = {
  search_listings: SearchListingsOperationModel
} as const;

// export type SearchOperationMapping =
// {
//     [K in keyof typeof models]: typeof models[K] extends new () => infer R ? R : never;
// }

export type SearchOperationMapping =
{
    [K in keyof typeof models]: InstanceType<typeof models[K]>;
}